interface Benefit {
  text: string;
}

interface IndustryCardProps {
  tag: string;
  headline: string;
  description: string;
  benefits: Benefit[];
  image: string;
  accent: string;
  index: number;
}

export default function IndustryCard({ tag, headline, description, benefits, image, accent, index }: IndustryCardProps) {
  const isEven = index % 2 === 0;

  return (
    <div className={`grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-3xl overflow-hidden bg-white border border-[#E2E8F0]/80 ${isEven ? '' : 'lg:[&>*:first-child]:order-2'}`}>
      {/* Image */}
      <div className="relative h-72 lg:h-auto min-h-[320px] overflow-hidden">
        <img
          src={image}
          alt={headline}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/50 to-transparent"></div>
        <div className="absolute top-6 left-6">
          <span
            className="text-xs font-bold px-4 py-1.5 rounded-full font-inter"
            style={{ backgroundColor: `${accent}20`, color: accent, border: `1px solid ${accent}30` }}
          >
            {tag}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-10 md:p-12 flex flex-col justify-center">
        <h3 className="text-[#0F172A] font-black text-3xl md:text-4xl mb-4 font-poppins leading-tight">{headline}</h3>
        <p className="text-[#334155]/55 text-base leading-relaxed mb-8 font-inter">{description}</p>

        <div className="space-y-3">
          {benefits.map((b, i) => (
            <div key={i} className="flex items-center gap-3">
              <div
                className="w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0"
                style={{ backgroundColor: `${accent}15` }}
              >
                <i className="ri-check-line text-xs" style={{ color: accent }}></i>
              </div>
              <span className="text-[#334155] text-sm font-inter">{b.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
